// removed by extract-text-webpack-plugin
module.exports = {"block":"subnavigation__block-1dIxa","container":"subnavigation__container-Up_Cc","underlined":"subnavigation__underlined-1oAwV","item":"subnavigation__item-1PmjL","isSelected":"subnavigation__isSelected-f6Xmf","isClickable":"subnavigation__isClickable-Bipan"};


//////////////////
// WEBPACK FOOTER
// ./~/account-ui/subnavigation/subnavigation.css
// module id = 863
// module chunks = 0